<template>
  <div class="records-shortcut-cell-wrapper" @click="$emit('click')">
    <div class="top-section">
      <div style="margin-right: 8px"><img :src="getIconURL" style="height: 40px; width: 40px" /></div>
      <div class="title-styling">{{title}}</div>
    </div>
    <div class="date-cell"><strong>{{date.datePrefix}}</strong> {{date.date}}</div>
  </div>
</template>

<script>
export default {
  name: 'ShortcutCellWithBorder',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    date: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getIconURL () {
      return require(`../statics/icons/${this.icon}.svg`)
    }
  }
}
</script>

<style scoped>
.records-shortcut-cell-wrapper {
  border: 1px solid #C9CBD5;
  border-radius: 8px;
  padding: 16px 0 16px 27px;
  cursor: pointer;
}

.records-shortcut-cell-wrapper:hover{
  background-color: #F9F9FA
}

.top-section {
  display: flex;
  align-items: center;
}

.title-styling {
  font-weight: 400;
  font-size: 16px;
}

.date-cell {
  margin-left: 45px;
  background: #F6EDF3;
  border-radius: 22px;
  padding: 6px 16px;
  color: #8E2666;
  font-size: 14px;
  width: 186px;
}
</style>
